import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import prepareAuthHeaders from "@utils/prepareAuthHeaders";
import { Account } from "@models/account";
import { ListResponse } from "@models/list-response";

const BASE_API_URL = process.env.REACT_APP_API_URL;

export const accountApi = createApi({
  reducerPath: "accountApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_API_URL}/accounts`,
    prepareHeaders: prepareAuthHeaders,
  }),
  tagTypes: ["Account"],
  endpoints: (builder) => ({
    createAccount: builder.mutation<Account, Partial<Account>>({
      invalidatesTags: ["Account"],
      query: (account: Partial<Account>) => {
        return {
          url: "",
          method: "POST",
          body: account,
        };
      },
    }),
    updateAccount: builder.mutation<
      Account,
      Partial<Account> & { id: string }
    >({
      invalidatesTags: ["Account"],
      query: ({ id, ...body }) => {
        return {
          url: id!,
          method: "PATCH",
          body,
        };
      },
    }),
    getAccounts: builder.query<ListResponse<Account>, void>({
      providesTags: ["Account"],
      query: () => "",
    }),
  }),
});

export const { useCreateAccountMutation, useUpdateAccountMutation, useGetAccountsQuery } = accountApi;
